import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { MsalGuard } from '@azure/msal-angular';
import { AccountInformationComponent } from './pages/account-information/account-information.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'account-information',
    pathMatch: 'full',
  },
  {
    path: 'account-information',
    component: AccountInformationComponent,
    canActivate: [MsalGuard],
    data: { title: 'Account Information', parent: 'Settings' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AccountRoutingModule {}
